let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("db3ID")).then(() => parcelRequire('dycHB'));